import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { Button } from 'react-bootstrap'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'

import Collapsible from '../collapsible'
import Validators from '../../utils/validators'

@observer(['agreements'])
export default class Agreements extends Component {

  constructor(props) {
    super(props)

    this.props.agreements.loadAllAgreements()
  }

  newAgreement(row) {
    this.props.agreements.newAgreement(row)
  }

  updateAgreement(row, cellName, cellValue) {
    this.props.agreements.updateAgreement(row)
  }

  deleteAgreement(id) {
    if (confirm("Are you sure you want to delete this agreement?")) {
      this.props.agreements.deleteAgreement(id)
    }
  }

  formatAgreement(cell, row) {
    return cell.substring(0, 100) + '...'
  }

  formatActions(cell, row) {
    return <Button bsSize="small" bsStyle="danger" id={ cell } onClick={ () => { this.deleteAgreement(cell) } }><i className="fa fa-trash" aria-hidden="true"></i></Button>
  }

  render() {
    const options = {
      onAddRow: this.newAgreement.bind(this)
    }

    const agreementsTable = (
      <BootstrapTable
          data={ this.props.agreements.data }
          striped={ true }
          hover={ true }
          pagination={ true }
          search={ true }
          exportCSV={ true }
          options={ options }
          insertRow={ true }
          bordered={ false }
          cellEdit={ { mode: 'click', blurToSave: true, afterSaveCell: this.updateAgreement.bind(this) } } >
        <TableHeaderColumn width="50" dataField="id" isKey={ true } dataSort={ true } dataAlign="center" hiddenOnInsert={ true } autoValue={ true }>ID</TableHeaderColumn>
        <TableHeaderColumn width="50" dataField="name" dataSort={ true } dataAlign="center">Name</TableHeaderColumn>
        <TableHeaderColumn width="150" dataField="agreement" dataSort={ true } dataFormat={ this.formatAgreement } editable={ { type: 'textarea', validator: Validators.validString } }>Agreement</TableHeaderColumn>
        <TableHeaderColumn width="50" dataField="id" hiddenOnInsert={ true } autoValue={ true } dataFormat={ this.formatActions.bind(this) }>Actions</TableHeaderColumn>
      </BootstrapTable>
    )

    return (
      <div>
        <Collapsible title="Agreements" content={ agreementsTable } />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/admin/agreements.js